import { isNonMedia } from './'

export const isFile = (contentType = '') => isNonMedia(contentType)

export default isFile
